<template>
	<form enctype="multipart/form-data">
		<notifications />

		<section class="heading">
			<h1 class="title">Settings</h1>
		</section>

		<!-- Nav tabs -->
		<ul id="setting-tabs" class="nav nav-tabs" role="tablist">
			<li role="presentation" class="active"><a href="#business-informations" aria-controls="business-informations" role="tab" data-toggle="tab">Business Informations</a></li>
			<li role="presentation"><a href="#billing" aria-controls="billing" role="tab" data-toggle="tab">Billing Information</a></li>
			<li role="presentation"><a href="#email-templates" aria-controls="email-templates" role="tab" data-toggle="tab">Email Templates</a></li>
			<li role="presentation"><a href="#terms-conditions" aria-controls="terms-conditions" role="tab" data-toggle="tab">Business Terms & Conditions</a></li>
		</ul>

		<!-- Tab panes -->
		<div class="tab-content">
			<div role="tabpanel" class="tab-pane active" id="business-informations">
				<business-informations 
					:onLogoChange="handleLogoChange"
					:isLoading="isLoading"
					:initialData="fields" 
				/>
			</div>
			<div role="tabpanel" class="tab-pane" id="billing">
				<billing-information 
					:isLoading="isLoading"
					:initialData="fields" 
				/>
			</div>
			<div role="tabpanel" class="tab-pane" id="email-templates">
				<email-templates 
					:isLoading="isLoading"
					:initialData="fields" 
				/>
			</div>
			<div role="tabpanel" class="tab-pane" id="terms-conditions">
				<terms-conditions
					:isLoading="isLoading"
					:initialData="fields"
					:errors="errors"
					:totalPercent="totalPercent" 
				/>
			</div>
		</div>

		<div class="settings-actions">
			<button 
				type="button" 
				class="btn btn-lg btn-primary" 
				@click="handleSubmit"
				:disabled="isLoading"
			>
				<i v-show="isLoading" class="fa fa-circle-o-notch fa-spin"></i>
				Save
			</button>
			<button 
				type="button" 
				class="btn btn-link btn-lg btn-cancel"
				@click="(e) => { e.preventDefault(); $router.back(); }"
			>
				Back
			</button>
		</div>

	</form>
</template>

<script>
import BusinessInformations from './BusinessInformations.vue';
import BillingInformation from './BillingInformation.vue';
import EmailTemplates from './EmailTemplates.vue';
import TermsConditions from './TermsConditions.vue';
import { defaultErrors, defaultFields } from './helpers';
import { pruneEmpty } from '../../helpers';

export default {
	components: {
		BusinessInformations,
		BillingInformation,
		EmailTemplates,
		TermsConditions,
	},
	data() {
		return {
			fields: defaultFields(),
			errors: defaultErrors(),
			formData: null,
			isLoading: false,
		}
	},
	computed: {
		totalPercent() {
			let items = this.fields.settings.payment_terms_template;
			let currentPercentage = items.reduce((subtotal, item) => {
				return parseFloat(subtotal) + parseFloat(item.percentage);
			}, 0);
			return 100 - currentPercentage;
		}
	},
	async beforeMount() {
		this.isLoading = true;

		try {
			let response = await axios.get('/settings');
			this.fields = this.formatData(response.data.data);
		} catch {
			this.showError();
		}

		this.isLoading = false;
	},
	mounted() {
		$('#setting-tabs a').click(function (e) {
			e.preventDefault()
			$(this).tab('show')
		});
	},
	methods: {
		async handleSubmit(e) {
			e.preventDefault();

			this.errors = defaultErrors();
			this.isLoading = true;

			if (!this.validateInputs()) {
				this.isLoading = false;
				return;
			}

			let cleanData = pruneEmpty(this.fields);
			cleanData = this.prepareForUpload(cleanData);

			try {
				await axios.post('/settings', cleanData);
				if (this.formData != null) {
					await axios.post('/settings', this.formData);
					this.formData = null;
				}
				$('.main-sidebar .user-panel .info .title').text(this.fields.user.name);
				this.$notify({
					type: 'success',
					title: 'Settings Saved!',
					text: 'You\'ve saved your settings!'
				})
			} catch {
				this.showError();
			}

			this.isLoading = false;
		},
		showError() {
			this.$notify({
				type: 'error',
				title: 'Oops!',
				text: 'Sorry, an error occured!'
			})
		},
		formatData(data) {
			if (data.settings.payment_terms_template === null) {
				data.settings.payment_terms_template = [];
			}

			return data;
		},
		prepareForUpload(data) {
			let newData = JSON.parse(JSON.stringify(data));
			if (!!newData.settings && !!newData.settings.payment_terms_template) {
				newData.settings.payment_terms_template = JSON.stringify(newData.settings.payment_terms_template);
			}
			delete newData.company.logo;
			return newData;
		},
		validateInputs() {
			if (this.totalPercent < 0) {
				this.errors.settings.payment_terms_template = 'Total percent must not be lower than 0, try to adjust the payment terms percentage.';
				$('a[href="#terms-conditions"]').tab('show');
				return false;
			}

			return true;
		},
		handleLogoChange($event) {
			if (this.formData === null) {
				this.formData = new FormData();
			}
			let file = $event.target.files[0];
			this.formData.set('company[logo]', file, file.name);

			let reader = new FileReader();

			reader.onload = e => {
				this.fields.company.logo = e.target.result;
			}

			reader.readAsDataURL($event.target.files[0]);
		}
	},
	watch: {
		'fields.settings.payment_terms_template': {
			handler() {
				if (this.totalPercent >= 0) {
					this.errors = defaultErrors();
				}
			},
			deep: true,
		}
	}
}
</script>

<style lang="less" scoped>
.settings-actions {
	margin-top: 30px;
	margin-bottom: 30px;
}
</style>
